var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drawer',{attrs:{"title":"Add comment"},on:{"updateClose":_vm.onClose,"updateSave":_vm.onSave}},[_c('field',{attrs:{"margin":"5px 0","width":"100%","label":"Note","min-height":"400px","placeholder":"Enter text","setInputValue":_vm.comment,"is-textarea":""},on:{"updateInput":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }